import React, { useContext } from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import loadable from '@loadable/component';
import { AppContext } from 'adapter';

const AccountView = loadable(() => import('./views/Account'));
const MineView = loadable(() => import('./views/Mine'));
const NotFoundView = loadable(() => import('./views/NotFound'));
const SignInView = loadable(() => import('./views/SignIn'));
const SignUpView = loadable(() => import('./views/SignUp'));
const SystemView = loadable(() => import('./views/System'));
const MetricsView = loadable(() => import('./views/Metric'));
// custom
const EndpointListView = loadable(
  () => import('./views/Endpoint/EndpointList')
);
const EndpointDetailView = loadable(
  () => import('./views/Endpoint/EndpointDetail')
);
const ProxyPoolListView = loadable(
  () => import('./views/ProxyPool/ProxyPoolList')
);
const ProxyPoolDetailView = loadable(
  () => import('./views/ProxyPool/ProxyPoolDetail')
);
const AccessRecordReportView = loadable(
  () => import('./views/AccessRecordReport')
);
const RedialScheduleView = loadable(() => import('./views/RedialSchedule'));

// for normal user
const UserMetricView = loadable(
  () => import('./views/Mine/components/UserMetric')
);
const UserWhiteIpListView = loadable(
  () => import('./views/Mine/components/WhiteIpList')
);

const PrivateRoute = ({ ...rest }) => {
  const { user } = useContext(AppContext);
  return !user.overdue ? (
    <RouteWithLayout {...rest} />
  ) : (
    <Redirect
      to={{
        pathname: '/sign-in',
      }}
    />
  );
};

const Routes = () => {
  return (
    <Switch>
      <Redirect exact from='/' to='/mine' />
      <PrivateRoute
        component={AccountView}
        exact
        layout={MainLayout}
        path='/accountList'
      />
      <PrivateRoute
        component={MineView}
        exact
        layout={MainLayout}
        path='/mine'
      />
      <PrivateRoute
        component={UserMetricView}
        exact
        layout={MainLayout}
        path='/userMetric'
      />
      <PrivateRoute
        component={UserWhiteIpListView}
        exact
        layout={MainLayout}
        path='/userWhiteIpList'
      />
      <PrivateRoute
        component={SystemView}
        exact
        layout={MainLayout}
        path='/systemSettings'
      />

      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path='/sign-in'
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path='/sign-up'
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path='/not-found'
      />
      <PrivateRoute
        component={MetricsView}
        exact
        layout={MainLayout}
        path='/metrics'
      />
      <PrivateRoute
        component={EndpointListView}
        exact
        layout={MainLayout}
        path='/endpointList'
      />
      <PrivateRoute
        component={ProxyPoolListView}
        exact
        layout={MainLayout}
        path='/proxyPoolList'
      />
      <PrivateRoute
        component={ProxyPoolDetailView}
        exact
        layout={MainLayout}
        path='/proxyPoolDetail/:poolKey'
      />
      <PrivateRoute
        component={EndpointDetailView}
        exact
        layout={MainLayout}
        path='/endPointDetail/:endpointId'
      />
      <PrivateRoute
        component={AccessRecordReportView}
        exact
        layout={MainLayout}
        path='/accessRecordReport'
      />
      <PrivateRoute
        component={RedialScheduleView}
        exact
        layout={MainLayout}
        path='/redialSchedule'
      />

      <Redirect to='/not-found' />
    </Switch>
  );
};

export default Routes;
